
import { motion } from 'framer-motion';

export default function CTASection() {
  return (
    <section className="relative h-screen overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/3d7e8ebf43218b5c82eaa8e60f6a3f5e.jpg" 
          alt="Start Your Career" 
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-dark-deep/75 via-dark-deep/60 to-dark-deep/75"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-20 h-full flex flex-col justify-between py-20">
        {/* Top Left Title */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mt-32"
        >
          <h2 className="text-8xl font-black text-white lowercase tracking-tight">
            start your career
          </h2>
        </motion.div>

        {/* Bottom Section */}
        <div className="flex items-end justify-between">
          {/* Bottom Left Button */}
          <motion.a
            href="https://onnyjob.kr"
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="group flex items-center gap-4 bg-white rounded-full h-16 pl-8 pr-2 shadow-[0_8px_32px_rgba(255,255,255,0.3)] hover:shadow-[0_8px_40px_rgba(255,255,255,0.5)] transition-all whitespace-nowrap cursor-pointer"
          >
            <span className="text-dark-purple font-bold text-lg">시작하기</span>
            <div className="w-12 h-12 bg-neon-purple rounded-full flex items-center justify-center">
              <i className="ri-arrow-right-line text-2xl text-white"></i>
            </div>
          </motion.a>

          {/* Bottom Right Text */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-right"
          >
            <p className="text-2xl text-white font-light leading-relaxed">
              지금 바로 온니잡에서<br />
              새로운 기회를 찾아보세요
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}